import { format } from "date-fns";
import { getStorage } from "store/local";
import proxy from "api/proxy";

const tagColorsState = {
  open: "amber",
  done: "sky",
  close: "neutral",
};

async function getDeepDomain() {
  const session = getStorage("ctxSession");
  const { data } = await proxy.search(
    "staff.section",
    [["chiefs.id", "=", Number(session?.user_employee)]],
    ["employees", "chiefs"],
  );
  const sections = data.map((val) => val["id"]);
  return [["section", "in", sections]];
}

function layout() {
  const ctxView = {
    model: "staff.access",
    selectable: "multi",
    table_action: [],
    form_action: ["edit"],
    limit: 500,
    activeSearch: true,
    domain: [], 
    fields: {
      employee: {
        type: "many2one",
        model: "company.employee",
        searchable: true,
        readOnly: true,
      },
      section: {
        type: "many2one",
        model: "staff.section",
        readOnly: true,
      },
      shift: {
        type: "many2one",
        model: "staff.shift",
        readOnly: true,
      },
      enter_timestamp: {
        type: "datetime",
        required: true,
      },
      exit_timestamp: {
        type: "datetime",
      },
      heno: {
        type: "float",
        readOnly: true,
      },
      hedo: {
        type: "float",
        readOnly: true,
      },
      henf: {
        type: "float",
        readOnly: true,
      },
      hedf: {
        type: "float",
        readOnly: true,
      },
      state: {
        type: "selection",
        readOnly: true,
        options: [
          { id: "open", name: "Abierto" },
          { id: "close", name: "Cerrado" },
          { id: "approved", name: "Aprobado" },
          { id: "not_approved", name: "No Aprob." },
        ],
        tags: tagColorsState,
      },
    },
    list: [
      { name: "employee" },
      { name: "section" },
      { name: "shift" },
      { name: "enter_timestamp" },
      { name: "exit_timestamp" },
      { name: "heno" },
      { name: "hedo" },
      { name: "hedf" },
      { name: "henf" },
    ],
  };

  return ctxView;
}

export { layout, getDeepDomain };
